import React from 'react';
import {Tag} from 'antd';
import {useTranslation} from 'react-i18next';
import {PodExemptStatus} from '../../graphql/podExempt/types';
import {POD_EXEMPT_STATUS_COLOR, POD_EXEMPT_STATUS_I18N} from './podExemptConstants';

interface Props {
  status: PodExemptStatus;
  /**
   * 生效库语境（「已通过的地址」页）：EFFECTIVE 读作「生效中」——描述当前仍在豁免；
   * 上报单语境读作「已生效」——描述审核结论。对齐原型两处不同用词。
   */
  effectiveLibrary?: boolean;
}

const PodExemptStatusTag: React.FC<Props> = ({status, effectiveLibrary = false}) => {
  const {t} = useTranslation();
  const i18nKey =
    effectiveLibrary && status === 'EFFECTIVE'
      ? 'podExempt.status.effectiveActive'
      : POD_EXEMPT_STATUS_I18N[status] ?? status;
  return <Tag color={POD_EXEMPT_STATUS_COLOR[status] ?? 'default'}>{t(i18nKey)}</Tag>;
};

export default PodExemptStatusTag;
